import { experimentManager } from './experiment-manager';

export const BEACONS_REFACTOR = experimentManager.create({
  id: 'f7f6a02f-b571-4472-959f-8cd3691327a6',
  variants: ['legacy', 'refactored'],
  volume: 1,
  criteria: () => true
});
